<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <label for="">Novo comentário</label>

    <b-overlay :show="!isInputsEnabled" rounded="lg" opacity="0.6">
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner></b-spinner>
          <strong>{{ $t("geral.sendingData") }}</strong>
        </div>
      </template>

      <b-form-textarea
        id="input-description"
        v-model="newComment.comment"
        placeholder="Escrever um comentário..."
        :disabled="!isInputsEnabled"
        @click="typingStart"
      />
      <div v-if="isTyping">
        <b-row>
          <b-col>
            <camera-button
              :lang="$i18n.locale"
              :disabled="!isInputsEnabled"
              @update-image-src="fileAdd"
            >
            </camera-button>
          </b-col>
          <b-col class="text-right">
            <span v-if="isCommentLengthValid">{{ commentLength }}/500</span>
            <span v-else class="text-danger"
              >Comentário maior que o permitido. {{ commentLength }}/500</span
            >
          </b-col>
        </b-row>
        <b-row
          class="text-center"
          v-if="
            newComment.attachments != null && newComment.attachments.length > 0
          "
        >
          <b-col
            md="3"
            v-for="(attachment, i) in newComment.attachments"
            :key="i"
          >
            <base-attachment-viewer
              class="ml-3 mb-3"
              :attachment="attachment"
              :discard-visible="isInputsEnabled"
              @discard="fileRemove"
            ></base-attachment-viewer
          ></b-col>
        </b-row>
        <div>
          <b-button
            size="sm"
            class="mr-2"
            :disabled="!isCommentLengthValid"
            @click="saveComment"
            variant="green"
          >
            {{ $t("geral.save") }}
          </b-button>
          <b-button
            size="sm"
            class="mr-2"
            :disabled="!isInputsEnabled"
            @click="typingCancel"
            variant="danger"
          >
            {{ $t("geral.discard") }}
          </b-button>
        </div>
      </div>
    </b-overlay>
    <!-- <div>{{newComment}}</div> -->
  </div>
</template>
<script>
export default {
  name: "StageNewComment",
  props: {
    filledId: Number,
    stageId: String,
    newComment: Object,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CameraButton: () => import("@/components_rms/CameraButton.vue"),
    BaseAttachmentViewer: () =>
      import("@/components_rms/base/BaseAttachmentViewer.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      // newComment: {
      //   comment: "",
      //   filledId: 0,
      //   stageName: "",
      //   stageId: 0,
      //   attachments: [],
      // },
      isInputsEnabled: true,
      isTyping: false,
    };
  },
  computed: {
    commentLength() {
      if (!this.newComment.comment) return 0;
      return this.newComment.comment.length;
    },
    isCommentLengthValid() {
      return this.commentLength <= 500;
    },
  },
  methods: {
    fileAdd(newValue) {
      this.newComment.attachments.push({ attachment: newValue });
      this.$forceUpdate();
    },
    fileRemove(attachment) {
      for (let i = this.newComment.attachments.length - 1; i >= 0; i--) {
        if (this.newComment.attachments[i].attachment == attachment) {
          this.newComment.attachments.splice(i, 1);
          break;
        }
      }
      this.$forceUpdate();
    },
    typingCancel() {
      this.newComment.attachments = [];
      this.newComment.comment = "";
      this.isTyping = false;
    },
    typingStart() {
      this.isTyping = true;
    },
    saveComment() {
      this.newComment.filledId = this.filledId;
      this.newComment.stageId = this.stageId;
      //   console.log(this.newComment);
      this.$apiWorkflow
        .post("/stage/saveComment/", this.newComment)
        .then((response) => {
          this.comements = response.data;
          this.$refs.alert.show();
          this.isInputsEnabled = true;
          this.typingCancel();
          this.$emit('onConfirm');
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            this.alerts.error = `${error.response.status} - ${error.response.statusText}`;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          } else {
            this.alerts.error = error;
            this.$refs.danger.show();
            this.isInputsEnabled = true;
          }
        });
    },
  },
};
</script>
